import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-s relative flex cursor-pointer items-center gap-2',
    text: 'hidden lg:block'
  }
});
